import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "social-facebook_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M22 12c0 4.992-3.657 9.13-8.438 9.88v-6.988h2.33L16.337 12h-2.773v-1.876c0-.791.387-1.562 1.63-1.562h1.26V6.102s-1.144-.195-2.238-.195c-2.285 0-3.777 1.384-3.777 3.89v2.204h-2.54v2.89h2.54v6.989C5.657 21.13 2 16.992 2 12 2 6.478 6.477 2 12 2s10 4.477 10 10Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }